import * as React from "react";
import type { SVGProps } from "react";
const SvgPartnership = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="m10.395 43.266 3.303-3.303a2.193 2.193 0 1 0-3.102-3.102l-3.303 3.303a2.193 2.193 0 0 0 3.102 3.102Zm4.54-7.642a3.943 3.943 0 0 0-5.576 0l-3.303 3.302a3.943 3.943 0 0 0 5.577 5.577l3.302-3.303a3.943 3.943 0 0 0 0-5.576Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="m14.588 47.679 3.303-3.303a2.193 2.193 0 0 0-3.101-3.102l-3.303 3.303a2.193 2.193 0 0 0 3.101 3.102Zm4.54-7.642a3.943 3.943 0 0 0-5.576 0l-3.303 3.303a3.943 3.943 0 1 0 5.577 5.576l3.303-3.303a3.943 3.943 0 0 0 0-5.576ZM34.665 53.217l-5.435-5.435 1.237-1.237 5.435 5.435a4.104 4.104 0 1 1-5.805 5.805l-2.98-2.981 1.237-1.238 2.98 2.981a2.355 2.355 0 0 0 3.33-3.33Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="m30.467 46.592 5.435 5.435a2.355 2.355 0 0 0 3.33-3.33l-5.435-5.435 1.238-1.238 5.435 5.435a4.105 4.105 0 0 1-5.805 5.805l-5.435-5.435 1.237-1.237Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="m35.036 42.024 5.435 5.435a2.355 2.355 0 1 0 3.33-3.33l-5.435-5.435 1.237-1.237 5.435 5.435a4.105 4.105 0 0 1-5.805 5.805l-5.435-5.435 1.238-1.238Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="m48.371 39.562-12.313-12.31 1.237-1.237 12.313 12.31a4.104 4.104 0 1 1-5.804 5.804l-5.435-5.435 1.238-1.237 5.435 5.435a2.354 2.354 0 1 0 3.329-3.33ZM43.72 10.643l-10.298 2.896a15.3 15.3 0 0 0-6.676 3.91l-9.154 9.154a2.355 2.355 0 0 0 3.33 3.33l5.434-5.436 1.238 1.238-5.435 5.435a4.105 4.105 0 1 1-5.805-5.805l9.155-9.154a17.051 17.051 0 0 1 7.439-4.356l10.298-2.897.473 1.685ZM19.274 52.145l3.303-3.303a2.193 2.193 0 1 0-3.102-3.101l-3.303 3.302a2.193 2.193 0 1 0 3.102 3.102Zm4.54-7.642a3.943 3.943 0 0 0-5.576 0l-3.303 3.303a3.943 3.943 0 0 0 5.577 5.576l3.302-3.302a3.943 3.943 0 0 0 0-5.577Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="m24.045 56.558 3.302-3.303a2.193 2.193 0 1 0-3.102-3.101l-3.302 3.302a2.193 2.193 0 1 0 3.102 3.102Zm4.54-7.642a3.943 3.943 0 0 0-5.577 0l-3.303 3.303a3.943 3.943 0 0 0 5.577 5.576l3.303-3.302a3.943 3.943 0 0 0 0-5.577Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M1.416 18.555a1 1 0 0 1 0-1.414L14.537 4.019a1 1 0 0 1 1.414 0l5.177 5.177a1 1 0 0 1 0 1.414L8.006 23.732a1 1 0 0 1-1.414 0l-5.176-5.177Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M3.183 17.848 7.3 21.964 19.36 9.904l-4.116-4.117-12.06 12.061Zm-1.767-.707a1 1 0 0 0 0 1.414l5.176 5.177a1 1 0 0 0 1.414 0L21.128 10.61a1 1 0 0 0 0-1.414l-5.177-5.177a1 1 0 0 0-1.414 0L1.416 17.141Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M48.048 4.02a1 1 0 0 1 1.414 0L62.584 17.14a1 1 0 0 1 0 1.414l-5.177 5.177a1 1 0 0 1-1.414 0L42.872 10.61a1 1 0 0 1 0-1.414l5.176-5.176Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M48.755 5.787 44.64 9.903 56.7 21.964l4.116-4.116-12.06-12.06Zm.707-1.767a1 1 0 0 0-1.414 0l-5.176 5.176a1 1 0 0 0 0 1.414l13.121 13.122a1 1 0 0 0 1.414 0l5.177-5.177a1 1 0 0 0 0-1.414L49.462 4.02Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="m29.39 14.359-9.548-3.643.623-1.635 9.55 3.643-.624 1.635Zm17.112 22.017 9.45-13.781 1.444.99-9.45 13.78-1.444-.989ZM9.657 35.8 6.605 23.297l1.7-.415 3.052 12.502-1.7.415ZM27.221 23.82a9.099 9.099 0 0 0 12.867 0l1.238 1.238c-4.237 4.236-11.106 4.236-15.342 0l1.237-1.238Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPartnership;
